import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LegacyProgressDto } from './legacy-progress-dto';
import { FileSaverService } from 'ngx-filesaver';
import { Observable } from 'rxjs';
import { OeAppService } from '../../shared/oe-app.service';
import { OeAppPersonService } from '../../shared/oe-app-person.service';

@Injectable()
export class LegacyProgressService {
  constructor(private httpClient: HttpClient, public fileSaver: FileSaverService, private oeAppService: OeAppService, private oeAppPersonService: OeAppPersonService) {}

  exportCertificatePdf(certificateLevel: number): Observable<Blob> {
    const downloadCertificateUrl = `${this.oeAppService.oeProgressServiceHost}/v1/certificates/pdf/${this.oeAppPersonService.id}/${certificateLevel}`;
    return this.httpClient.get(downloadCertificateUrl, { responseType: 'blob' });
  }

  downloadCertificatePdf(certificateLevel: number) {
    this.exportCertificatePdf(certificateLevel).subscribe(response => {
      this.fileSaver.save(<any>response, `certificate_level${certificateLevel}.pdf`);
    });
  }
}



// WEBPACK FOOTER //
// ./ts/app/certificates/legacy-progress-service/legacy-progress.service.ts